import { Http } from '@mygpt/app/http';

export interface UpdateDictionaryParams {
  aiId: string;
  dictionaryId: string;
  source: string;
  target: string;
}
/**
 * 更新字典
 * @param params
 * @returns
 */
export const updateDictionaryService = (params: UpdateDictionaryParams) => {
  const { post } = Http.use();
  return post(`/robots/${params.aiId}/dictionaries/${params.dictionaryId}`, {
    source: params.source,
    target: params.target,
  });
};
